module.exports = __webpack_public_path__ + "img/mask.fab01693.svg";